import { ApiResponse } from "@/domain";
import { backendApi } from "../../rest/backendApi";

export interface HealthCheckServiceStatus {
  healthy: boolean;
  responseTime: number;
  lastChecked: number;
  error?: string;
}

export interface HealthCheckPostgresStatus extends HealthCheckServiceStatus {
  servers?: never;
}

export interface HealthCheckAfipStatus extends HealthCheckServiceStatus {
  servers?: {
    appServer: string;
    dbServer: string;
    authServer: string;
  };
}

export interface HealthCheckResponse {
  status: 'healthy' | 'degraded';
  timestamp: number;
  services: {
    postgres: HealthCheckPostgresStatus;
    afip: HealthCheckAfipStatus;
  };
}

export const healthApi = {
  getStatus: () =>
    backendApi.get<ApiResponse<HealthCheckResponse>>('/api/v1/health').then((res) => res.data.data),
};
